<template>
	<div class="sampleInforClass">
		<div class="leftClass">
			<span :class="activeIndexB == index ? 'spanNameClass2' : 'spanNameClass'" v-for="(item, index) in dataObject" :key="index" @click="changeItem(item, index)">
				<img :src="activeIndexB == index ? item.img1 : item.img2" />
				{{ item.name }}
			</span>
		</div>
		<div class="rightClass">
			<moonSampleIndex @borrowItemFunc="borrowItemFunc" v-if="activeIndexB == 0"></moonSampleIndex>

			<mySampleVue ref="mySampleRef" v-else-if="activeIndexB == 1"></mySampleVue>
			<sampleBorrwingVue v-else-if="activeIndexB == 2"></sampleBorrwingVue>
			<sampleReturnVue v-else-if="activeIndexB == 3"></sampleReturnVue>

			<!-- <sampleBorrowingVue v-else-if="activeIndexB == 4" @borrowItemNext="borrowItemNext" ref="borrowRef"></sampleBorrowingVue> -->
			<mySampleReturnVue v-else-if="activeIndexB == 5"></mySampleReturnVue>

			<sampleSubmitVue v-else-if="activeIndexB == 4"></sampleSubmitVue>
		</div>
		<!-- <div class="rightClass2" v-else>
        <sampleBorrwingVue v-if="activeIndexB ==4" ></sampleBorrwingVue>
      <sampleReturnVue v-else-if="activeIndexB ==5"></sampleReturnVue>
    </div> -->
	</div>
</template>

<script>
import sampleBorrwingVue from '../sampleInfo/sampleBorrwing.vue'
import sampleReturnVue from '../sampleInfo/sampleReturn.vue'
import moonSampleIndex from './sampleSearch/moonSampleIndex.vue'
import mySampleVue from './mySample.vue'
import sampleBorrowingVue from './mySampleBorrowing.vue'
import mySampleReturnVue from './mySampleReturnVue.vue'
import sampleSubmitVue from '../sampleInfo/sampleSubmit.vue'
export default {
	components: {
		sampleBorrwingVue,
		sampleReturnVue,
		moonSampleIndex,
		sampleBorrowingVue,
		mySampleVue,
		mySampleReturnVue,
		sampleSubmitVue
	},
	data() {
		return {
			ruleFlag: true,
			activeIndexB: 0,
			dataObject: [
				{ img1: require('./../../../assets/moonsamples/有色金属2.png'), img2: require('./../../../assets/moonsamples/有色金属2.png'), name: '可借用样品查询' },

				{ img1: require('./../../../assets/moonsamples/样本.png'), img2: require('./../../../assets/moonsamples/样本2.png'), name: '我的样品' },

				{ img1: require('./../../../assets/moonsamples/流程委托1.png'), img2: require('./../../../assets/moonsamples/流程委托2.png'), name: '样品借用流程' },
				{ img1: require('./../../../assets/moonsamples/流程还1.png'), img2: require('./../../../assets/moonsamples/流程还2.png'), name: '样品返还流程' },
				{ img1: require('./../../../assets/moonsamples/样本.png'), img2: require('./../../../assets/moonsamples/样本2.png'), name: '样品申请再提交' }

				// {img1:require('./../../../assets/moonsamples/ic_refresh.png'), img2:require('./../../../assets/moonsamples/ic_refresh1.png'), name:'样品借用'},
				// {img1:require('./../../../assets/moonsamples/库房管理-领用归还.png'), img2:require('./../../../assets/moonsamples/库房管理-领用归还2.png'), name:'样品返还'},
			]
		}
	},
	mounted() {},
	methods: {
		changeItem(item, index) {
			this.activeIndexB = index
		},
		// borrowItemFunc(item){
		//   console.log(item)
		//   this.activeIndexB = 1
		//   this.$nextTick(()=>{
		//     this.$refs.borrowRef.borrowInit(item)
		//   })
		// },
		returnItemFunc(item) {
			this.activeIndexB = 2
		},
		borrowItemFunc() {
			this.activeIndexB = 1
			this.$nextTick(() => {
				this.$refs.mySampleRef.mySampleInit()
			})
		}
	}
}
</script>

<style lang="scss" scoped>
.sampleInforClass {
	min-width: 1200px;
	margin: 0 auto;
	margin-top: 20px;
	margin-bottom: 20px;
	display: flex;
	justify-content: center;
	min-height: 100vh;
	.leftClass {
		width: 240px;
		height: auto;
		border-radius: 4px;
		background-color: #fff;
		.spanNameClass,
		.spanNameClass2 {
			cursor: pointer;
			height: 40px;
			font-family: MicrosoftYaHeiUI;
			font-size: 18px;
			color: #333333;
			display: flex;
			font-style: normal;
			align-items: center;
			line-height: 40px;
			padding-top: 20px;
			padding-left: 20px;
			img {
				padding-right: 10px;
			}
		}
		.spanNameClass2 {
			color: #2a8eec;
		}
	}
	.rightClass {
		display: flex;
		// width: 900px;
		margin-left: 20px;
		flex-direction: column;
		height: auto;
	}
	.rightClass2 {
		display: flex;
		width: 900px;
		margin-left: 20px;
		flex-direction: column;
		height: auto;
	}
}
</style>